import BaiduMaps from './baidu-maps';
export default BaiduMaps;
